import { drawToCanvas, toTensorData } from "./preprocess.js";
import { interpret } from "./interpret.js";
import { softmax } from "./math.js";

export class DogAffectClassifier {
  constructor({ loader, ortLoader, wasmBase }) {
    this.loader = loader;
    this.ortLoader = ortLoader;
    this.wasmBase = wasmBase;
    this.session = null;
    this.metadata = null;
    this.canvas = null;
    this.ort = null;
  }

  get ready() {
    return Boolean(this.session);
  }

  async init(onProgress = () => {}) {
    this.metadata = await this.loader.loadMetadata();
    const bytes = await this.loader.loadModelBytes(this.metadata, onProgress);
    this.ort = await this.ortLoader();
    this.ort.env.wasm.wasmPaths = this.wasmBase;
    this.ort.env.wasm.numThreads = globalThis.crossOriginIsolated ? Math.min(4, globalThis.navigator?.hardwareConcurrency || 1) : 1;
    this.session = await this.ort.InferenceSession.create(bytes, { executionProviders: ["wasm"], graphOptimizationLevel: "all" });
    return this.metadata;
  }

  async logits(source, mode = "center") {
    if (!this.session) throw new Error("Classificatore non inizializzato");
    const { size, mean, std } = this.metadata.input;
    this.canvas ||= document.createElement("canvas");
    const pixels = drawToCanvas(source, size, this.canvas, mode);
    const tensor = new this.ort.Tensor("float32", toTensorData(pixels, mean, std), [1, 3, size, size]);
    const inputName = this.session.inputNames[0];
    const outputName = this.session.outputNames[0];
    const output = await this.session.run({ [inputName]: tensor });
    return Array.from(output[outputName].data);
  }

  async probabilities(source, mode = "center") {
    return softmax(await this.logits(source, mode), this.metadata.temperature || 1);
  }

  async classify(source, mode = "center") {
    return interpret(await this.probabilities(source, mode), this.metadata);
  }

  describe(probs) {
    return interpret(probs, this.metadata);
  }
}
